export const DEFAULT_ACCEPT_STRING = [
  'image/*',
  '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx',
  '.txt,.csv,.rtf,.md',
  '.zip,.rar,.7z,.tar,.gz',
  '.json,.xml,.mp3,.wav,.mp4,.mov',
].join(',')

export const DEFAULT_ALLOWED_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/bmp',
  'image/svg+xml',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'text/csv',
  'application/rtf',
  'application/zip',
  'application/x-rar-compressed',
  'application/x-7z-compressed',
  'application/x-tar',
  'application/gzip',
  'application/json',
  'application/xml',
  'audio/mpeg',
  'audio/wav',
  'video/mp4',
  'video/quicktime',
]

export const DEFAULT_ALLOWED_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.webp',
  '.bmp',
  '.svg',
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.txt',
  '.csv',
  '.rtf',
  '.md',
  '.zip',
  '.rar',
  '.7z',
  '.tar',
  '.gz',
  '.json',
  '.xml',
  '.mp3',
  '.wav',
  '.mp4',
  '.mov',
]
